import { franc } from 'franc-min';

// Regex pattern for detecting Russian text
const russianPattern = /[а-яА-ЯёЁ]/;

export interface TextSegment {
  text: string;
  language: 'ru' | 'fr' | 'en';
}

export const detectLanguage = (text: string): 'ru' | 'fr' | 'en' => {
  // First check for Russian text
  if (russianPattern.test(text)) {
    return 'ru';
  }

  // Use franc to detect between French and English
  const detectedLang = franc(text, { only: ['eng', 'fra'] });
  return detectedLang === 'fra' ? 'fr' : 'en';
};

export const segmentText = (text: string): TextSegment[] => {
  // Split by Russian text boundaries
  const segments: TextSegment[] = [];
  let currentText = '';
  let isInRussian = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const isRussian = russianPattern.test(char);

    if (isRussian !== isInRussian) {
      // Language boundary detected
      if (currentText.trim()) {
        segments.push({
          text: currentText.trim(),
          language: isInRussian ? 'ru' : detectLanguage(currentText.trim())
        });
      }
      currentText = char;
      isInRussian = isRussian;
    } else {
      currentText += char;
    }
  }

  // Add the last segment
  if (currentText.trim()) {
    segments.push({
      text: currentText.trim(),
      language: isInRussian ? 'ru' : detectLanguage(currentText.trim())
    });
  }

  // Merge adjacent non-Russian segments of the same language
  const mergedSegments: TextSegment[] = [];
  let currentSegment: TextSegment | null = null;

  for (const segment of segments) {
    if (!currentSegment) {
      currentSegment = segment;
    } else if (segment.language === currentSegment.language && segment.language !== 'ru') {
      currentSegment.text += ' ' + segment.text;
    } else {
      mergedSegments.push(currentSegment);
      currentSegment = segment;
    }
  }

  if (currentSegment) {
    mergedSegments.push(currentSegment);
  }

  return mergedSegments;
};